import styled from 'styled-components'
import { ReactElement, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useUserStore } from '../../../store/user/UserStore'
import { Spinner } from 'react-bootstrap'
import ShowNotification from '../../../ui-components/modals/ToastNotifcationNotiStack'
import { ToastNotificationVariant } from '../../../ui-components/util/Interfaces'
import UserInfoServiceOpProvider from '../../../services/UserInfoServiceOpProvider'
import UserInfoServiceProvider from '../../../services/UserInfoServiceProvider'
import { setUserSession, backupCurrentSession } from '../helper'
import { SalesPadOrg } from '../../../services/SalesPadServiceProvider'
import { defaultTheme } from '../../../theme'

interface Props {
  org: SalesPadOrg
}

const OrgBox = observer((props: Props): ReactElement => {
  const { org } = props
  const [loading, setLoading] = useState(false)
  const userStore = useUserStore()

  const handleClick = async (): Promise<void> => {
    try {
      setLoading(true)

      // Backup the current session before switching to a new organization
      backupCurrentSession()

      const orgId = org.childOrgId
      const key = await userStore.createSalesRepUserInfoCognito(orgId)
      const token = await UserInfoServiceProvider.generateV3Token(key)
      const credentails =
        await UserInfoServiceOpProvider.generateV3Credentials(token)
      setUserSession(credentails, 'true', 'true')
      window.location.reload()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      ShowNotification({
        message: 'contactUsFormErrorMessage',
        variant: ToastNotificationVariant.ERROR,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box onClick={handleClick} $isCSC={org.isCSC}>
      {loading ? <StyledSpinner /> : org.childOrgName}
    </Box>
  )
})

const Box = styled.div<{ $isCSC?: boolean }>`
  display: flex;
  padding: 20px;
  background-color: ${defaultTheme.colors.white};
  cursor: pointer;

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  vertical-align: middle;

  box-shadow: ${({ $isCSC }) =>
    $isCSC
      ? `inset 0 0 0 4px ${defaultTheme.colors.blueLight}`
      : `inset 0 0 0 1px ${defaultTheme.colors.border}`};

  &:hover {
    box-shadow: ${({ $isCSC }) =>
      $isCSC
        ? `inset 0 0 0 4px ${defaultTheme.colors.blueLight}, inset 0 0 0 6px ${defaultTheme.colors.black}`
        : `inset 0 0 0 2px ${defaultTheme.colors.black}`};
  }
`

const StyledSpinner = styled(Spinner)`
  margin: auto;
`

export default OrgBox
